export default __webpack_public_path__ + "button_bknmsg.2216d7.png";